import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import * as React from 'react';
import { CheckboxButton, CustomTooltip } from '@cian/ui-kit';
import { CalendarPicker } from '@cian/ui-kit/DateInput/internal/components/CalendarPicker';
import { formatDateLabel } from '../../../utils/formatters';
import * as styles from './datepicker.css';
import { getDate } from '../../../utils/getDate';
import { getCalendarDay } from '../../../utils/getCalendarDay';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var Datepicker = function Datepicker(_ref) {
  var checked = _ref.checked,
    onSelectDate = _ref.onSelectDate,
    isOpen = _ref.isOpen,
    setOpen = _ref.setOpen,
    minDay = _ref.minDay,
    maxDay = _ref.maxDay,
    disabledDays = _ref.disabledDays;
  var _React$useState = React.useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    selectedDate = _React$useState2[0],
    setSelectedDate = _React$useState2[1];
  var selectDate = React.useCallback(function (date) {
    setSelectedDate(date);
    onSelectDate(date);
    setOpen(false);
  }, [setSelectedDate, onSelectDate, setOpen]);
  var open = React.useCallback(function (event) {
    setOpen(true);
    event.stopPropagation();
  }, [setOpen]);
  var handleClose = React.useCallback(function () {
    setOpen(false);
  }, [setOpen]);
  var buttonRef = React.useRef(null);
  return /*#__PURE__*/_jsxs("div", {
    className: styles['container'],
    onClick: function onClick(event) {
      event.stopPropagation();
    },
    children: [/*#__PURE__*/_jsx(CheckboxButton, {
      label: formatDateLabel(selectedDate),
      checked: checked,
      onClick: open,
      ref: buttonRef,
      size: "M"
    }), /*#__PURE__*/_jsx(CustomTooltip, {
      open: isOpen,
      anchorRef: buttonRef,
      arrow: false,
      closeButton: false,
      outside: true,
      onClose: handleClose,
      content: /*#__PURE__*/_jsx(CalendarPicker, {
        selected: selectedDate ? getDate(selectedDate) : null,
        onChange: function onChange(date) {
          return selectDate(getCalendarDay(date));
        },
        min: getDate(minDay),
        max: getDate(maxDay),
        disabledDates: disabledDays.map(getDate)
      })
    })]
  });
};